import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import "react-google-flight-datepicker/dist/main.css";
import "react-date-range/dist/theme/default.css";
import {
  getAllBlocksFromDistrict,
  getdistictName,
  school_name_block_wise,
} from "../api/Users";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";

import { Button } from "@mui/material";
function TransferDWO() {
    const { t } = useTranslation();
    const handleClick = (e) => {
      i18next.changeLanguage(e.target.value);
    };
    const [sameBlock, setSameBlock] = useState(true);
    const [acrossBlock, setAcrossBlock] = useState(false);
    const [block, setBlock] = useState("");
    const [destinationBlock, setdestinationBlock] = useState("");
    const [DistrictName, setDistrictName] = useState([]);
    const [Allblocks, setAllBlocks] = useState([]);
    const [destinationAllBlocks, setDestinationAllBlocks] = useState([]);
    const [District, setDistrict] = useState("");
    const [destinationDistrict, setDestinationDistrict]=useState("");
    const [showTransferTbl, setShowTransferTbl] = useState(true);
    const [AllSchoolNames, setAllSchoolNames] = useState([]);
    const [destinationAllSchoolNames, setdestinationAllSchoolNames] = useState([]);
  
    console.log(AllSchoolNames);
  
    const getDistictNames = () => {
      getdistictName()
        .then((res) => {
          if (res.status === "success") {
            // const filteredDistricts = res.data.filter(
            //   (district) => district.district_code === userData.data.district_code
            // );
            setDistrictName(res.data);
          }
        })
        .catch((err) => {
          console.error("Error fetching assets:", err);
        });
    };
  
    useEffect(() => {
      getDistictNames();
    }, []);
  
    const handleBlockSelect = (e) => {
      const selectedBlock = e.target.value;
      setBlock(e.target.value);
      const data = {
        block_code: selectedBlock,
      };
      school_name_block_wise(data)
        .then((response) => {
          if (response.status == "success") {
            setAllSchoolNames(response.data.result);
          } else {
            setAllSchoolNames([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching districts:", error);
        });
    };
  
    const HandleDestinationBlockSelect = (e)=>{
      const selectedBlock = e.target.value;
      setdestinationBlock(e.target.value);
      const data = {
        block_code: selectedBlock,
      };
      school_name_block_wise(data)
        .then((response) => {
          if (response.status == "success") {
            setdestinationAllSchoolNames(response.data.result);
          } else {
            setdestinationAllSchoolNames([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching districts:", error);
        });
    }
  
    const handleDistrictChange = (e) => {
      const selectedDistrict = e.target.value;
      setDistrict(selectedDistrict);
      getAllBlocksFromDistrict(selectedDistrict)
        .then((res) => {
          if (res.status === "success") {
            setAllBlocks(res.data.new_asset_query);
          } else {
            setAllBlocks([]);
          }
        })
        .catch((err) => {
          console.error("Error fetching blocks:", err);
        });
    };
  
    const handleDestinationDistrictChange =(e)=>{
      const selectedDistrict = e.target.value;
      setDestinationDistrict(selectedDistrict);
      getAllBlocksFromDistrict(selectedDistrict)
        .then((res) => {
          if (res.status === "success") {
            setDestinationAllBlocks(res.data.new_asset_query);
          } else {
            setDestinationAllBlocks([]);
          }
        })
        .catch((err) => {
          console.error("Error fetching blocks:", err);
        });
    }
  
    return (
      <div className="row">
        <div className="col-12 d-flex row justify-content-start m-0">
          <div className="my-4 col-6 d-flex justify-content-between align-items-center">
            <h3 className="my-4" style={{ color: "#0b3c85" }}>
              {t("Transfer Panel-DWO")}
            </h3>
          </div>
          <div className="container p-4 pt-">
            {showTransferTbl && (
              <div className="container mt-5" style={{ display: "flex" }}>
                <section style={{ width: "45%" }}>
                  <div className="row d-flex justify-content-around">
                    <div className="col-md-5 p-3 card">
                      <h4 className="d-flex justify-content-start">
                        Transfer From
                      </h4>
                      <div className="row col-12">
                        <div className="col-md-12 my-2 text-center">
                          <select
                            class="form-control"
                            onChange={handleDistrictChange}
                            value={District}
                          >
                            <option value="" selected={true}>
                              {t("Select District")}
                            </option>
                            {DistrictName &&
                              DistrictName.map((row, id) => (
                                <option
                                  key={id}
                                  value={row.district_code}
                                  className="text-dark"
                                >
                                  {row.name}
                                </option>
                              ))}
                          </select>
                        </div>
                        
                        <div className="col-md-12">
                          <input
                            type="text"
                            name="headmaster1"
                            className="form-control"
                            placeholder="DWO Name"
                            disabled
                          />
                        </div> 
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="col-md-1 mb-4 pb-4 d-flex align-items-center justify-content-center"
                  style={{ width: "10%", alignItems: "center" }}
                >
                  <div>
                    <TransferWithinAStationIcon
                      className="text-primary"
                      style={{
                        fontSize: "70px",
                        writingMode: "vertical-lr",
                      }}
                    />
                  </div>
                </section>
                <section style={{ width: "45%" }}>
                  <div className="row d-flex justify-content-around">
                    <div className="col-md-5 p-3 card">
                      <h4 className="d-flex justify-content-start">
                      {t("Transfer To")}
                      </h4>
                      <div className="col-md-12 my-2 text-center">
                        <select class="form-control" onChange={handleDestinationDistrictChange}>
                          <option>{t("Select District")}</option>
                          {DistrictName &&
                            DistrictName.map((row, id) => (
                              <option
                                key={id}
                                value={row.district_code}
                                className="text-dark"
                              >
                                {row.name}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="row col-12">
                        
                      </div>
                      <div className="col-md-12 my-4">
                        <label htmlFor="formFile my-2">
                          Upload Transfer Order
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          name="formFile"
                          accept="application/pdf"
                          id="formFile"
                        />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            )}
            <div class="row mt-3">
              <div class="d-flex justify-content-end">
                <button class="form-label btn btn-primary" type="submit">
                  Transfer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

export default TransferDWO